export default __webpack_public_path__ + "static/media/gallery6.3a37bc93.jpg";